import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useBrand } from "@/context/BrandContext";
import api, { apiError } from "@/lib/api";
import { EnvelopeSimple, ArrowLeft, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const brand = useBrand();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#08111F] p-6 text-white">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/[0.03] p-6" data-testid="forgot-page">
        <Link to="/login" data-testid="back-to-login" className="mb-4 flex items-center gap-1 text-sm text-white/60"><ArrowLeft size={14} /> Back to sign in</Link>
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/20 text-primary"><CheckCircle size={28} weight="fill" /></div>
            <h1 className="mt-4 font-display text-xl font-semibold">Check your email</h1>
            <p className="mt-2 text-sm text-white/60">If an account exists for <span className="font-medium text-white">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.</p>
            <p className="mt-3 text-xs text-white/40">Your username is always your email address.</p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground"><EnvelopeSimple size={24} weight="duotone" /></div>
            <h1 className="mt-4 font-display text-2xl font-semibold tracking-tight">Forgot password?</h1>
            <p className="mt-2 text-sm text-white/60">Enter your account email and we'll send you a link to set a new password. (Your username is your email.)</p>
            {error && <div data-testid="forgot-error" className="mt-4 rounded-lg bg-destructive/20 px-3 py-2 text-sm text-red-300">{error}</div>}
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com"
              className="mt-5 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 outline-none focus:border-primary" />
            <button data-testid="forgot-submit" disabled={busy}
              className="mt-4 w-full rounded-full bg-primary py-3.5 font-semibold text-primary-foreground transition-transform hover:scale-[1.02] disabled:opacity-60">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
